import { jsx } from '@emotion/react/jsx-runtime';
import { createComponentWithRef, useSlot, DisabledEffect } from '@nettbureau/core';
import { useCss, cloneElementWithCss } from '@nettbureau/styling';

/**
 * An internal component with basic styling providing a foundation for an input field.
 */ const BaseInput = createComponentWithRef((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('BaseInput', props, ref);
    const { children, color = 'neutral', css, disabled, lineHeight = 'regular', size = 'inherit', weight, ...otherProps } = mergedProps;
    const inputCss = useCss(({ theme, mixins })=>[
            {
                background: 'transparent',
                border: 'inherit',
                display: 'block',
                '&::placeholder': {
                    color: 'currentcolor',
                    opacity: theme.opacities.placeholder
                }
            },
            mixins.size({
                width: '100%'
            }),
            mixins.typography({
                color,
                lineHeight,
                size,
                weight
            })
        ]);
    return /*#__PURE__*/ jsx(DisabledEffect, {
        disabled: disabled,
        children: cloneElementWithCss(children, {
            ...otherProps,
            css: [
                inputCss,
                css
            ],
            disabled,
            ref: mergedRef
        })
    });
});

export { BaseInput };
//# sourceMappingURL=base-input.js.map
